export default __webpack_public_path__ + "static/reels-cf0e3639deb988250453f6336beb68e7.jpg";